const routes = [
    {
        path: "/exam/schedules/observer",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    },
];

export default routes;
